<template>
  <div id="app" :class="[isheng ? 'transformRotate' : 'transformRotate1']">
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {
      isheng: false,
    };
  },
  mounted() {
    if (navigator.userAgent.match(/(iPhone|Android|iPad)/i)) {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (width < height) {
        this.isheng = true;
        window.addEventListener("resize", this.renderResize);
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.renderResize);
  },
  methods: {
    renderResize() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (width > height) {
        this.isheng = false;
      } else {
        this.isheng = true;
      }
    },
  },
};
</script>
<style>
@import url("@/assets/global.css");
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
.transformRotate {
  transform: rotate(90deg);
  width: 100vh;
  height: 100vw;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50vw;
  margin-left: -50vh;
}
.transformRotate1 {
  width: 100vw;
  height: 100vh;
}
</style>
